module.exports = __webpack_public_path__ + "media/images/grade/S-fccb5386ef01fcee64e42c0f984e7639.svg";